export const environment = {
  baseUrl: 'https://api-sandbox.payee.tech/admin',
  afterLoginPath: '/admin',
  production: false,

  appUrl: 'https://sandbox.payee.tech',
  paymentUrl: 'https://payment-sandbox.payee.tech',

  titleSuffix: '(Sandbox)',

  HELP_URL: 'https://help.payee.tech/hu/',
};
